<script>
    import {onMount, onDestroy} from 'svelte';
    import debounce from 'debounce';

    export let draggable = true;
    export let onResize = () => {};
    const onResizeDebounced = debounce(onResize, 100);

    let element;
    let leftPanel;
    let rightPanel;
    let container;

    function onDragStart(event) {
        const ghost = this.cloneNode(true);
        ghost.style.display = "none";
        event.dataTransfer.setDragImage(ghost, 0, 0);
    }

    function onDrag(event) {
        if (event.clientX) {
            const width = event.clientX - container.offsetLeft;
            leftPanel.style.width = width + 'px';
            adjustRightPanelWidth();
            onResizeDebounced(container, leftPanel, rightPanel);
        }
    }

     function handleWindowResize(event){
        adjustRightPanelWidth();
        onResizeDebounced(container, leftPanel, rightPanel);
    }

    function adjustRightPanelWidth(){
        if(rightPanel.offsetWidth < 1200){
            rightPanel.classList.add('sm');
        } else {
            rightPanel.classList.remove('sm');
        }
    }


    onMount(() => {
        leftPanel = element.previousElementSibling;
        leftPanel.style.width = leftPanel.offsetWidth + 'px';
        rightPanel = element.nextElementSibling;
        adjustRightPanelWidth();
        container = leftPanel.parentElement;
    });
</script>


<style>
    .splitter {
        background-color: #9FA6AB;
        width: 3px;
        cursor: ew-resize;
    }
</style>

<svelte:window on:resize={handleWindowResize} />

<div
    bind:this={element}
    {draggable}
    on:dragstart={onDragStart}
    on:drag={onDrag}
    class="splitter"/>
